import React, { useEffect } from 'react'
import AuthRoutes from '../../routes/auth/AuthRoutes'
import UserLayout from '../user/UserLayout'
import { useUser } from '../../hooks/useUser'
import { useSettings } from '../../hooks/useSetting'

const AuthLayout = () => {

    const { user, logout } = useUser()
    const { settings } = useSettings()


    useEffect(() => {
        let accessToken = localStorage.getItem('access_token')
        let refreshToken = localStorage.getItem('refresh_token')
        if (!accessToken || !refreshToken) {
            logout()
        }
    }, [])

    return (
        <>
            {!user.isLogin ? (<AuthRoutes />) : (<UserLayout />)}
            {settings.isLoading && (
                <div className='fixed inset-0 z-[2000] flex justify-center items-center bg-white/20 backdrop-blur-sm'>
                    <div className="rounded-md h-12 w-12 border-4 border-t-4 border-primary animate-spin"></div>
                </div>
            )}
        </>
    )
}

export default AuthLayout